import { roundToNearestMinutes, startOfToday } from 'date-fns';

import getUTCDate from 'lib/common/utils/getUTCDate';

import { buildAllQueuesStats, buildQueueStats } from '../utils/getAgentStats';

export default async function getAgentMetrics({ fetch_, config, agentQueues }) {
  try {
    const startTime = getUTCDate(startOfToday()).toISOString();
    const nowInUTC = getUTCDate();
    const endTime = roundToNearestMinutes(nowInUTC, { nearestTo: 5 }).toISOString();

    const metricsRes = await fetch_(`${config.AGENT_SERVICE_URL}/connect/${config.TENANT_ID}/metrics`, {
      method: 'POST',
      body: JSON.stringify({
        StartTime: startTime,
        EndTime: endTime,
        Queues: agentQueues?.map(({ Id }) => Id),
        ServiceLevel: 60,
        Groupings: ['QUEUE'],
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const metrics = await metricsRes.json();

    return {
      allQueuesStats: buildAllQueuesStats({ metrics }),
      queuesStats: buildQueueStats({ metrics, agentQueues }),
    };
  } catch {
    return {};
  }
}
